const Content = ({ salaryDetails, viewMode, selectedMonth, pdRef }) => {
  if (!salaryDetails) {
    return <div>No salary details available. Please select a year.</div>;
  }

  const { monthlySalaryRecords, currentSalary, employeeId, employeeType } =
    salaryDetails;

  const getMonthlyData = () => {
    if (monthlySalaryRecords.length > 0) {
      const yearRecord = monthlySalaryRecords[0];
      return yearRecord.monthlyData.find(
        (data) => parseInt(data.month) === selectedMonth
      );
    }
    return null;
  };

  const monthlyData = viewMode === 'monthly' ? getMonthlyData() : null;

  return (
    <div
      ref={pdRef}
      className="mx-auto max-w-3xl rounded-lg bg-white p-8 shadow-sm dark:!bg-navy-700"
    >
      {/* Header Section */}
      <div className="flex w-full flex-col justify-between rounded-[20px] p-7 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none md:h-[190px] md:flex-row">
        <div className="mb-4">
          <p className="text-base text-gray-600">Invoice for:</p>
          <p className="mb-1.5 mt-[13px] text-xl font-bold text-navy-700 dark:text-white">
            {employeeId.name}
          </p>
          <p className="leading-2 lg:text-md text-base text-gray-600">
            {employeeType}
          </p>
          <p className="leading-2 lg:text-md text-base text-gray-600">
            {employeeId.email}
          </p>
        </div>

        <div className="flex flex-col items-start">
          <p className="mb-2 mr-20 text-base text-gray-600">Annual Salary</p>
          <p className="mb-1.5 text-[35px] font-bold text-navy-700 dark:text-white lg:text-[40px]">
            ₹ {currentSalary}
          </p>

          {/* Calculating monthly and daily salary */}
          <p className="text-lg text-gray-600">
            Monthly Salary: ₹ {(currentSalary / 12).toFixed(2)}
          </p>
          {/* <p className="text-lg text-gray-600">
            Daily Salary: ₹ {(currentSalary / 365).toFixed(2)}
          </p> */}
        </div>
      </div>

      {/* Monthly View */}
      {viewMode === 'monthly' && monthlyData ? (
        <div className="space-y-6 dark:!bg-navy-700">
          <div className="mb-6 flex items-center justify-between">
            <div>
              <h2 className="text-lg font-semibold">Pay Period</h2>
              <p className="text-gray-600">
                {new Date(2000, selectedMonth - 1).toLocaleString('default', {
                  month: 'long',
                })}{' '}
                {/* 1 - 30, 2024 */}
              </p>
            </div>
          </div>

          <div className="space-y-4">
            <div className="flex justify-between border-b py-3">
              <span className="text-gray-600">Gross Pay</span>
              <span className="font-semibold">₹{monthlyData.amount}</span>
            </div>

            <div className="flex justify-between border-b py-3">
              <span className="text-gray-600">Bonus</span>
              <span className="font-semibold text-green-600">
                +₹{monthlyData.bonus}
              </span>
            </div>

            <div className="flex justify-between border-b py-3">
              <span className="text-gray-600">Deductions</span>
              <span className="font-semibold text-red-600">
                -₹{monthlyData.deductions}
              </span>
            </div>

            <div className="mt-4 flex justify-between border-t-2 py-3">
              <span className="font-semibold">Net Amount</span>
              <span className="text-lg font-bold">
                ₹{monthlyData.netAmount}
              </span>
            </div>
          </div>
        </div>
      ) : (
        /* Yearly View */
        <div>
          {monthlySalaryRecords.map((record, index) => (
            <div key={index} className="mb-8">
              <h3 className="mb-4 text-lg font-semibold">
                Salary Records - {record.year}
              </h3>
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="border-b">
                      <th className="py-3 text-left text-gray-600">Month</th>
                      <th className="py-3 text-right text-gray-600">
                        Gross Pay
                      </th>
                      <th className="py-3 text-right text-gray-600">Bonus</th>
                      <th className="py-3 text-right text-gray-600">
                        Deductions
                      </th>
                      <th className="py-3 text-right text-gray-600">
                        Net Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {record.monthlyData.map((monthData, monthIndex) => (
                      <tr key={monthIndex} className="border-b">
                        <td className="py-3">
                          {new Date(2000, monthData.month - 1).toLocaleString(
                            'default',
                            { month: 'long' }
                          )}
                        </td>
                        <td className="text-right">₹{monthData.amount}</td>
                        <td className="text-right text-green-600">
                          +₹{monthData.bonus}
                        </td>
                        <td className="text-right text-red-600">
                          -₹{monthData.deductions}
                        </td>
                        <td className="text-right font-semibold">
                          ₹{monthData.netAmount}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Content;
